<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                      'bg-gray-600': sharedService.userTheme === 'dark',
                      'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row padding10">
        <h4>Upload Proficiency Test</h4>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-col" *ngIf="editMode == 'process'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-700': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <form [formGroup]="formGroup">
          <div class="flex flex-col">

            <mat-form-field>
              <mat-label>Evaluator</mat-label>
              <mat-select formControlName="Evaluator">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let evaluator of eval" [value]="evaluator.code">{{evaluator.code}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>

            <div class="flex flex-row flex-wrap gap-4 sm:flex-col">
              <div class="file-upload">
                <button mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()">
                  Select File
                  <mat-icon>attach_file</mat-icon>
                </button>
              </div>
              <div class="flex flex-col" *ngIf="fileName != ''">
                <span>File Selected for Upload:</span>
                <span>{{fileName}}</span>
              </div>
              <span class="flex-1"></span>
              <div>
                <button mat-raised-button color="accent" (click)="uploadFiles()">
                  Upload
                </button>
              </div>
            </div>

          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>


  <!-- List Mode -->
  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-700': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col">

          <div class="flex flex-col">
            <h4>Proficiency Upload Review</h4>
            <span>Evaluator: <strong>{{evaluator}}</strong></span><br />
            <span>Total Results: <strong>{{listInvalid.length + listValidMicro.length +
                listValidNonMicro.length}}</strong></span><br />
            <span>Total Labs: <strong>{{labNames.length}}</strong></span>
          </div>

          <span style="width: 100%;border-top: 1px solid gray; padding-top: 10px;"></span>

          <div class="panel-heading">
            <h5>Invalid Tests</h5>
          </div>

          <div class="flex flex-col" *ngIf="listInvalid.length == 0">
            <span>No Invalid Tests Were Found</span>
          </div>

          <div class="flex flex-col" *ngIf="listInvalid.length > 0">
            <div class="flex flex-row">
              <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
                <input matInput id="listFilter" (keyup)="filterTable($event)" placeholder="Filter"
                  value="{{listFilter}}" />

                <button *ngIf="listFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                  class="mat-elevation-z8 w-full" matSortActive="test" matSortDirection="asc">
                  <ng-container matColumnDef="test">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>PT Test</th>
                    <td mat-cell *matCellDef="let item">{{item.test}}</td>
                  </ng-container>
                  <ng-container matColumnDef="testId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Test ID</th>
                    <td mat-cell *matCellDef="let item">{{item.testId}}</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
            </mat-paginator>
          </div>

          <span style="width: 100%;border-top: 1px solid gray; padding-top: 10px;"></span>

          <div class="flex flex-row flex-wrap gap-4 sm:flex-col">
            <div class="flex flex-col" *ngIf="listValidMicro.length > 0">
              <h5>Micro Tests Ready to Submit</h5>
            </div>
            <div class="flex flex-col" *ngIf="listValidMicro.length == 0">
              <h5>No Micro Tests Were Found</h5>
            </div>
            <span class="flex-1"></span>
            <div class="flex flex-row">
              <button *ngIf="listValidMicro.length > 0" mat-raised-button color="primary" (click)="savePtTests()">
                Load PTs
              </button>
              <button mat-raised-button color="warn" (click)="reset()">
                Return to Uploads
              </button>
            </div>
          </div>

          <div class="flex flex-col" *ngIf="listValidMicro.length > 0">
            <div class="flex flex-row">
              <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
                <input matInput id="listFilter2" (keyup)="filterTable2($event)" placeholder="Filter"
                  value="{{listFilter2}}" />

                <button *ngIf="listFilter2" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter2()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table mat-table [dataSource]="dataSource2" multiTemplateDataRows matSort #TableSort2="matSort"
                  class="mat-elevation-z8 w-full" matSortActive="labName" matSortDirection="asc">
                  <ng-container matColumnDef="labName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                    <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="test">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Test</th>
                    <td mat-cell *matCellDef="let item">{{item.test}}</td>
                  </ng-container>
                  <ng-container matColumnDef="percent">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Percent %</th>
                    <td mat-cell *matCellDef="let item">{{item.percent}}</td>
                  </ng-container>
                  <ng-container matColumnDef="year">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Year</th>
                    <td mat-cell *matCellDef="let item">{{item.year}}</td>
                  </ng-container>
                  <ng-container matColumnDef="period">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Period</th>
                    <td mat-cell *matCellDef="let item">{{item.period}}</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="getPageSizeOptions2()" #TablePaginator2="matPaginator"
              showFirstLastButtons>
            </mat-paginator>
          </div>

          <span style="width: 100%;border-top: 1px solid gray; padding-top: 10px;"></span>

          <div class="flex flex-row flex-wrap gap-4 sm:flex-col">
            <div class="flex flex-col" *ngIf="listValidNonMicro.length > 0">
              <h5>Non-Micro Tests Ready to Submit</h5>
            </div>
            <div class="flex flex-col" *ngIf="listValidNonMicro.length == 0">
              <h5>No Non-Micro Tests Were Found</h5>
            </div>
            <span class="flex-1"></span>
            <div class="flex flex-row">
              <button *ngIf="listValidNonMicro.length > 0" mat-raised-button color="primary" (click)="savePtTests()">
                Load PTs
              </button>
              <button mat-raised-button color="warn" (click)="reset()">
                Return to Uploads
              </button>
            </div>
          </div>

          <div class="flex flex-col" *ngIf="listValidNonMicro.length > 0">
            <div class="flex flex-row">
              <mat-form-field class="flex-1 min-w-[30%] sm:min-w-full">
                <input matInput id="listFilter3" (keyup)="filterTable3($event)" placeholder="Filter"
                  value="{{listFilter3}}" />

                <button *ngIf="listFilter3" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter3()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <div style="overflow-x:auto">
              <div class="flex flex-row">
                <table mat-table [dataSource]="dataSource3" multiTemplateDataRows matSort #TableSort3="matSort"
                  class="mat-elevation-z8 w-full" matSortActive="labName" matSortDirection="asc">
                  <ng-container matColumnDef="labName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                    <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="test">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Test</th>
                    <td mat-cell *matCellDef="let item">{{item.test}}</td>
                  </ng-container>
                  <ng-container matColumnDef="percent">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Percent %</th>
                    <td mat-cell *matCellDef="let item">{{item.percent}}</td>
                  </ng-container>
                  <ng-container matColumnDef="year">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Year</th>
                    <td mat-cell *matCellDef="let item">{{item.year}}</td>
                  </ng-container>
                  <ng-container matColumnDef="period">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Period</th>
                    <td mat-cell *matCellDef="let item">{{item.period}}</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="getPageSizeOptions3()" #TablePaginator3="matPaginator"
              showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

</div>